import {
	Component,
	OnInit,
	Input,
	Output,
	ViewEncapsulation,
	OnDestroy,
	EventEmitter,
	ChangeDetectorRef
} from "@angular/core";
import { IdService } from "../../shared/services/id.service";
import { isMobile } from "../../shared/utils/mobile";
import { IStep } from "../stepper.types";
import { IPointEvent } from "../../point/point.interface";

@Component({
	selector: "rbc-stepper-standalone",
	templateUrl: "./stepper-standalone.component.html",
	styles: [],
	encapsulation: ViewEncapsulation.None
})
export class StepperStandaloneComponent implements OnInit, OnDestroy {
	/**
	 * Force user to follow flow. Disables clicking on Stepper Points.
	 */
	@Input() followFlow = false;

	/**
	 * Stepper steps.
	 */
	@Input() steps: Array<IStep> = [];

	/**
	 * Show step numbers.
	 */
	@Input() stepNumber = false;

	/**
	 * Emit event when stepper point changes.
	 */
	@Output() pointUpdate = new EventEmitter();

	/**
	 * Stepper ID.
	 */
	public id: string;

	/**
	 * Flag for mobile device.
	 */
	public isMobile: boolean;

	/**
	 * Progress Bar progress value.
	 */
	public progress = 0;

	constructor(private idService: IdService, private cdrf: ChangeDetectorRef) {}

	/**
	 * Initialize component properties and set Points.
	 */
	public ngOnInit(): void {
		this.isMobile = isMobile();
		this.id = this.idService.generate();

		this.setPoints();
	}

	/**
	 * Remove Stepper ID from ID Service.
	 */
	public ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	/**
	 * Handle Point Update.
	 *
	 * @param event
	 */
	public handlePointUpdate(event: IPointEvent): void {
		if (event.active) {
			this.steps.forEach(step => {
				step.active = event.id === step.id;
			});

			this.updateProgress();

			this.pointUpdate.emit(event);
		}
	}

	/**
	 * Set Points.
	 */
	private setPoints(): void {
		this.steps = this.steps.map((point, key) => {
			// If follow flow is true, then disable all points except first one.
			if (this.followFlow && key !== 0 && !point.completed) {
				point.disabled = true;
			}

			// Set Point ID.
			point.id = `${this.id}-step-${key}`;

			return point;
		});

		// If there is no active Point, then make first step to be active.
		if (!this.steps.find(point => point.active)) {
			this.steps[0].active = true;
		}
	}

	/**
	 * Update Progress Bar value.
	 */
	private updateProgress(): void {
		if (this.followFlow) {
			const activeStepIndex = this.steps.findIndex(step => step.active);

			if (activeStepIndex >= 0) {
				this.progress = (activeStepIndex / (this.steps.length - 1)) * 100;
				this.cdrf.detectChanges();
			}
		}
	}
}
